<template>
  <transition name="fade">
    <div
      v-if="visible"
      class="mask">
      <div class="dialog">
        <div
          v-if="showClose"
          class="dialog-close"
          @click="handleClose">
          <i class="eqf-no"></i>
        </div>
        <div
          v-if="!noTitle"
          class="dialog-title">{{ title }}</div>
        <div class="dialog-body">
          <slot></slot>
        </div>
        <div
          v-if="$slots.footer"
          class="dialog-footer">
          <slot name="footer"></slot>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
export default {
  name: 'MallDialog',
  props: {
    title: {
      type: String,
      default: '提示'
    },
    visible: {
      type: Boolean,
      default: false
    },
    showClose: {
      type: Boolean,
      default: true
    },
    noTitle: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleClose() {
      this.$emit('close')
    }
  }
}
</script>
<style lang="scss" scoped>
.mask {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 999;
}
.dialog {
  position: fixed;
  min-width: 260px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 999;
  background-color: #fff;
  border: 1px solid #e6e6e6;
  border-radius: 2px;
  &-close {
    position: absolute;
    top: 15px;
    right: 15px;
    cursor: pointer;
    font-size: 16px;
    z-index: 2;
  }
  &-title {
    padding: 0 80px 0 20px;
    height: 42px;
    line-height: 42px;
    border-bottom: 1px solid #eee;
    font-size: 14px;
    color: #333;
    overflow: hidden;
    background-color: #f8f8f8;
    border-radius: 2px 2px 0 0;
  }
  &-body {
    position: relative;
    line-height: 24px;
    word-break: break-all;
    font-size: 14px;
    overflow: auto;
  }
  &-footer {
    margin: 10px 0;
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: all 0.3s ease;
}
.fade-enter,
.fade-leave-to {
  bottom: 0;
  opacity: 0;
}
</style>
